import React, { FC, ReactElement, useEffect, useState } from "react";
import styles from "./PhotoSection.module.css";
import photoOrdering from "../../photoOrdering.json";
import PhotoColumn from "../PhotoColumn/PhotoColumn";

interface PhotoSectionProps {
  setCarousel: Function;
}

const PhotoSection: FC<PhotoSectionProps> = ({ setCarousel }) => {
  const [photoColumns, setPhotoColumns] = useState(() =>
    updatePhotoColumns(setCarousel)
  );

  useEffect(() => {
    let resizeTimeout: ReturnType<typeof setTimeout>;

    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        setPhotoColumns(updatePhotoColumns(setCarousel));
      }, 50);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(resizeTimeout);
    };
  }, [setCarousel]);

  return <div className={styles.PhotoSection}>{photoColumns}</div>;
};

function updatePhotoColumns(setCarousel: Function): ReactElement {
  if (window.innerWidth <= 900) {
    return <PhotoColumn photos={photoOrdering} setCarousel={setCarousel} />;
  } else {
    return (
      <>
        <PhotoColumn photos={filterPhotos(true)} setCarousel={setCarousel} />
        <PhotoColumn photos={filterPhotos(false)} setCarousel={setCarousel} />
      </>
    );
  }
}

function filterPhotos(
  evenIndexed: boolean
): { name: string; width: number; height: number }[] {
  return photoOrdering.filter((photo, index) => {
    let includePhoto: boolean;
    if (evenIndexed) {
      includePhoto = index % 2 === 0;
    } else {
      includePhoto = index % 2 !== 0;
    }
    return includePhoto;
  });
}

export default PhotoSection;
